import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperativeListComponent } from './components/operative-list/operative-list.component';
import { OperativeDetailsComponent } from './components/operative-details/operative-details.component';
import { OperativeEditorComponent } from './components/operative-editor/operative-editor.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OperativeTrainingRecordsComponent } from './components/operative-training-records/operative-training-records.component';
import { OperativeDocumentsComponent } from './components/operative-documents/operative-documents.component';
import { OperativeHistoryComponent } from './components/operative-history/operative-history.component';
import { OperativeObservationsComponent } from './components/operative-observations/operative-observations.component';
import { DocumentsModule } from "../documents/documents.module";
import { SharedModule } from "../shared/shared.module";
import { ObservationModule } from '../observations/observation.module';
import { EngagementHistoryEditorComponent } from './components/engagement-history-editor/engagement-history-editor.component';
import { CommonsModule } from "../common/commons.module";
import { TrainingRecordsModule } from "../training-records/training-records.module";
import { OperativeDocumentsPageComponent } from './components/operative-documents-page/operative-documents-page.component';
import { OperativeDocumentDetailsPageComponent } from './components/operative-document-details-page/operative-document-details-page.component';
import { EngagementHistoryModalComponent } from './components/engagement-history-modal/engagement-history-modal.component';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { OperativeEditorModalComponent } from './components/operative-editor-modal/operative-editor-modal.component';
import { OperativesLeaveConfirmComponent } from './components/operatives-leave-confirm/operatives-leave-confirm.component';
import { ToastModule } from 'primeng/toast';
import { Slider, SliderModule } from 'primeng/slider';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { OperativeDetailsDocumentsListComponent } from './components/operative-details-documents-list/operative-details-documents-list.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { OperativeUploadComponent } from './components/operative-upload/operative-upload.component';
import { FileUploadModule } from 'primeng/fileupload';
import { OperativeUploadFormComponent } from './components/operative-upload-form/operative-upload-form.component';

@NgModule({
  declarations: [OperativeListComponent,
    OperativeDetailsComponent,
    OperativeEditorComponent,
    OperativeTrainingRecordsComponent,
    OperativeDocumentsComponent,
    OperativeHistoryComponent,
    OperativeObservationsComponent,
    EngagementHistoryEditorComponent,
    OperativeDocumentsPageComponent,
    OperativeDocumentDetailsPageComponent,
    EngagementHistoryModalComponent,
    OperativeEditorModalComponent,
    OperativesLeaveConfirmComponent,
    OperativeDetailsDocumentsListComponent,
    OperativeUploadComponent,
    OperativeUploadFormComponent,
  ],

  imports: [
    CommonModule,
    FontAwesomeModule,
    CardModule,
    InputTextareaModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    ContextMenuModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    SliderModule,
    MultiSelectModule,
    CalendarModule,
    TableModule,
    RouterModule,
    DocumentsModule,
    SharedModule,
    ObservationModule,
    CommonsModule,
    TrainingRecordsModule,
    InputSwitchModule,
    TabViewModule,
    FileUploadModule
  ],

  exports: [
    OperativeListComponent,
    OperativeDetailsComponent,
    OperativeObservationsComponent,
  ]
})

export class OperativesModule { }
